import React from 'react'
import { BoldText } from '../../../components/Text'
import SimpleForm, { IActionButton } from '../../../components/SimpleForm'
import RadioButton from '../../../components/RadioButton'
import validators from '../../../utils/validators'
import TextArea from '../../../components/TextArea'
import Input from '../../../components/Input'

interface IAllowedVotersFormProps {
  addVoters: (payload: IAllowedVotersFormPayload) => void
}

export interface IAllowedVotersFormPayload {
  type: "per_email" | "per_domain",
  allowed_email_domain?: string,
  voter_emails?: string,
}

const AllowedVotersForm = ({addVoters}: IAllowedVotersFormProps) => {
  const formFields = [
    {
      name: 'type',
      component: RadioButton,
      label: 'Type',
      validate: validators.required,
      options: [
        { value: "per_email", label: "Add voters by email" },
        { value: "per_domain", label: "Add voters by domain" }
      ]
    },
    {
      name: "allowed_email_domain",
      placeholder: "Email Domain (eg matuskii.com or facebook.com)",
      label: "Users with email ending in this domain will be allowed to vote",
      component: Input,
      dependencies: { type: { eq: "per_domain" } },
      validate: validators.isEmailDomain,
    },
    {
      name: 'voter_emails',
      label: 'Voters',
      component: TextArea,
      placeholder: 'Enter voters email',
      dependencies: { type: { eq: "per_email" } }
    }
  ]

  const actionButtons: IActionButton = {
    label: 'Save',
    isSubmit: true,
    loading: false,
    disabled: false,
  }

  return (
    <div>
      <BoldText variant="medium" center>Enter Voter Email</BoldText>
      <SimpleForm 
        formFields={formFields}
        actionButtons={actionButtons}
        submitForm={addVoters}
      />
    </div>
  )
}

export default AllowedVotersForm